import {Button} from 'antd';
import cn from 'classnames';

import cls from './T2Button.module.scss'

export const T2Button = (props:any) => (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Button {...props} className={cn([cls.button, props.className])} type={'primary'} size={'large'}/>
)